import { implementationProofById } from './implementationProofs';
const SPERANT_MANUAL_URL = 'https://sperant.gitbook.io/manual-sperant';
const SALESFORCE_REAL_ESTATE_URL = 'https://www.salesforce.com/solutions/industries/real-estate/';
const CLAIM_CAPTURED_AT = '2026-03-25T00:00:00.000Z';
const HOURS_PER_DAY = 24;
const DEFAULT_FRESHNESS_TTL_DAYS = 30;
const DEFAULT_FRESHNESS_TTL_HOURS = HOURS_PER_DAY * DEFAULT_FRESHNESS_TTL_DAYS;
const HIGH_CONFIDENCE_FINANCE_FIRST = 0.84;
const HIGH_CONFIDENCE_AI_INTEGRATED = 0.74;
const MEDIUM_CONFIDENCE_AI_BENCHMARK = 0.68;
const HIGH_CONFIDENCE_IMMUTABLE_TRACEABILITY = 0.77;
const MEDIUM_CONFIDENCE_IMMUTABLE_BENCHMARK = 0.6;
const HIGH_CONFIDENCE_PERU_NATIVE = 0.73;
const MEDIUM_CONFIDENCE_PERU_NATIVE_BENCHMARK = 0.65;
const HIGH_CONFIDENCE_MIGRATION_WEDGE = 0.82;
function buildEvidence(sourceUrl, confidence) {
    return {
        sourceUrl,
        capturedAt: CLAIM_CAPTURED_AT,
        freshnessTtlHours: DEFAULT_FRESHNESS_TTL_HOURS,
        confidence,
    };
}
export const comparisonProofClaims = [
    {
        id: 'comparison_finance_first',
        pagePath: '/comparar',
        titleKey: 'comparison:whySection.items.financeFirst.title',
        bodyKey: 'comparison:whySection.items.financeFirst.body',
        proofIds: ['payment_event_traceability', 'voucher_ocr_traceability'],
        evidence: [
            buildEvidence(SPERANT_MANUAL_URL, HIGH_CONFIDENCE_FINANCE_FIRST),
        ],
    },
    {
        id: 'comparison_ai_integrated',
        pagePath: '/comparar',
        titleKey: 'comparison:whySection.items.aiIntegrated.title',
        bodyKey: 'comparison:whySection.items.aiIntegrated.body',
        proofIds: ['voucher_ocr_traceability', 'queue_audit_integrity'],
        evidence: [
            buildEvidence(SPERANT_MANUAL_URL, HIGH_CONFIDENCE_AI_INTEGRATED),
            buildEvidence(SALESFORCE_REAL_ESTATE_URL, MEDIUM_CONFIDENCE_AI_BENCHMARK),
        ],
    },
    {
        id: 'comparison_immutable_traceability',
        pagePath: '/comparar',
        titleKey: 'comparison:whySection.items.immutableTraceability.title',
        bodyKey: 'comparison:whySection.items.immutableTraceability.body',
        proofIds: ['audit_hash_chain', 'queue_audit_integrity'],
        evidence: [
            buildEvidence(SPERANT_MANUAL_URL, HIGH_CONFIDENCE_IMMUTABLE_TRACEABILITY),
            buildEvidence(SALESFORCE_REAL_ESTATE_URL, MEDIUM_CONFIDENCE_IMMUTABLE_BENCHMARK),
        ],
    },
    {
        id: 'comparison_peru_native',
        pagePath: '/comparar',
        titleKey: 'comparison:whySection.items.peruNative.title',
        bodyKey: 'comparison:whySection.items.peruNative.body',
        proofIds: ['tenant_isolation_sql_scope', 'payment_event_traceability'],
        evidence: [
            buildEvidence(SPERANT_MANUAL_URL, HIGH_CONFIDENCE_PERU_NATIVE),
            buildEvidence(SALESFORCE_REAL_ESTATE_URL, MEDIUM_CONFIDENCE_PERU_NATIVE_BENCHMARK),
        ],
    },
    {
        id: 'comparison_migration_wedge',
        pagePath: '/comparar',
        titleKey: 'comparison:migrationWedge.title',
        bodyKey: 'comparison:migrationWedge.body',
        proofIds: ['voucher_ocr_traceability', 'backup_recovery_controls'],
        evidence: [
            buildEvidence(SPERANT_MANUAL_URL, HIGH_CONFIDENCE_MIGRATION_WEDGE),
        ],
    },
];
export function assertProofGatedClaims() {
    for (const claim of comparisonProofClaims) {
        if (claim.proofIds.length === 0) {
            throw new Error(`Public proof claim ${claim.id} is missing repo proofs`);
        }
        if (claim.evidence.length === 0) {
            throw new Error(`Public proof claim ${claim.id} is missing evidence`);
        }
        for (const proofId of claim.proofIds) {
            if (!implementationProofById[proofId]) {
                throw new Error(`Public proof claim ${claim.id} references unknown proof ${proofId}`);
            }
        }
        for (const evidence of claim.evidence) {
            const sourceUrl = evidence.sourceUrl.trim();
            if (!sourceUrl.startsWith('https://')) {
                throw new Error(`Public proof claim ${claim.id} has unsupported evidence URL ${sourceUrl}`);
            }
            if (evidence.freshnessTtlHours <= 0) {
                throw new Error(`Public proof claim ${claim.id} has invalid TTL for ${sourceUrl}`);
            }
            if (evidence.confidence <= 0 || evidence.confidence > 1) {
                throw new Error(`Public proof claim ${claim.id} has invalid confidence for ${sourceUrl}`);
            }
        }
    }
}
assertProofGatedClaims();
